/** @jsx jsx */
import React from "react"
import { graphql } from "gatsby"
import { jsx, Box, Container, Heading, Flex } from "theme-ui"
import CardWrapper from "../../shared/CardWrapper"

export const query = graphql`
  fragment ContentfulResourcesReferencesFragment on ContentfulResourcesReferences {
    headline
    referencedContent {
      ... on ContentfulBlogPost {
        __typename
        contentful_id
        description
        featuredImageAltText
        slug
        title
        featuredImage {
          gatsbyImageData(width: 960)
          file {
            url
          }
        }
      }
      ... on ContentfulCaseStudy {
        __typename
        contentful_id
        description
        slug
        title
        featuredImageCaption
        featuredImageAltText
        featuredImage {
          gatsbyImageData(width: 960)
          file {
            url
          }
        }
      }
      ... on ContentfulPage {
        __typename
        contentful_id
        internalName
        description
        sections {
          ... on ContentfulHeroSection {
            ...ContentfulHeroSectionFragment
          }
        }
        featuredImageAltText
        slug
        featuredImage {
          gatsbyImageData(width: 960)
          file {
            url
          }
        }
      }
    }
  }
`

const ResourcesReference = ({ sectionContent }) => {
  const { headline, referencedContent } = sectionContent
  const cardTitle = referencedContent.map((item, index) => ({
    title: item.__typename === "ContentfulPage" ? item.internalName : item.title,
    index,
  }))

  return (
    <Container variant="containerSecondary" sx={{ py: ["16px", "32px", "64px"] }}>
      <Box
        sx={{
          textAlign: "center",
          margin: ["0 auto 0", "0 auto 30px"],
        }}
      >
        {headline && (
          <Heading as="h3" variant="bold" pb="20px">
            {headline}
          </Heading>
        )}
      </Box>
      <Flex
        sx={{
          gap: "30px",
          flexWrap: ["wrap", "wrap", "wrap", "nowrap"],
        }}
      >
        {referencedContent.map((item, index) => {
          let path = ""
          switch (item.__typename) {
            case "ContentfulCaseStudy":
              path = "/case-studies"
              break
            case "ContentfulBlogPost":
              path = "/blog"
              break
            case "ContentfulPage":
              path = ""
              break
            default:
              path = ""
          }

          return (
            <Box
              key={index}
              sx={{
                justifyContent: "center",
              }}
            >
              <CardWrapper
                item={{
                  heading: cardTitle[index]?.title,
                  image: item.featuredImage,
                  imageAltText: item.featuredImageAltText,
                  linkUrl: `${path}/${item.slug}`,
                  description: item.description,
                  cardHeight: "520px",
                }}
                imageFit="cover"
              />
            </Box>
          )
        })}
      </Flex>
    </Container>
  )
}

export default ResourcesReference
